import { Box, Tooltip} from '@mui/material';
import { makeStyles } from '@mui/styles';

import React from 'react';

import PermissionButton from '../PermissionButton';

const useStyles = makeStyles(() => ({
    headerList: {
        display: 'flex',
        alignItems: 'stretch',
        gap: '0',
        padding: '0 0 16px',
        fontSize: "0.82rem",
        flexWrap: 'wrap',
    },
    ListInsideViewDetails: {
        justifyContent: 'flex-start',
        paddingTop: '0px',
    },
    itemCard: {
        flex: '1 1 0',
        minWidth: '140px',
        background: '#fff',
        borderRight: '1px solid #e8edf3',
        padding: '14px 18px',
        transition: 'background 0.2s ease',
        '&:first-child': {
            borderRadius: '10px 0 0 10px',
        },
        '&:last-child': {
            borderRight: 'none',
            borderRadius: '0 10px 10px 0',
        },
        '&:hover': {
            background: '#f0f7ff',
        },
        '& b': {
                color: 'darkcyan',
    width: 'max-content',
    /* border-top: 1px solid #008b8b; */
    display: 'block',
    padding: '2px',
    fontSize: '0.75rem',
    fontWeight: 700,
    /* border-radius: 8px; */
    /* text-decoration: underline; */
    marginBottom: 6,
    letterSpacing: 0.5,
    textTransform: 'uppercase',
    borderBottom: '1px solid #008b8b',
        },
        '& .item-value': {
        color: 'darkslategray',
        fontSize: '0.84rem',
        fontWeight: 700,
        lineHeight: 1.4,
        display: 'flex',
        justifyContent: 'flex-start',
        width: 'fit-content',
        },
    },
}));

const ListContent = ({ column, data, enableEdit }) => {
    const { type, display, mapping, tooltip, text, optionset, editable } = column;
    if (editable && enableEdit) {
        return (
            <>
                {column.renderEditField()}
            </>)
    }
    if (type === "empty") {
        return (<></>)
    } else if (type === "icon") {
        return (
            <Box width={"100%"} textAlign={"center"}>
                <span style={{ display: 'inline-flex', alignItems: 'center' }}>
                    {column.icon()}
                </span>
            </Box>)
    } else if (tooltip) {
        return (
            <Tooltip key={`${display}-tooltip`} title={data[tooltip]}>
                <div>
                    {data[mapping] || "--"}
                </div>
            </Tooltip>
        )
    } else if (type === "button") {
        return (
            <Box width={"100%"} textAlign={"center"}>
                <PermissionButton
                    permission={column.permission}
                    variant="contained"
                    color="primary"
                    className={'actionButton'}
                    onClick={column.handleCallback}
                >
                    {text}
                </PermissionButton>
            </Box>
        )
    } else if (type === "custom") {
        return (
            <>
                {column.renderCustom()}
            </>
        )
    } else if (optionset) {

        return optionset[data[mapping]] || data[mapping] || "--";
    }
    return data[mapping] || "--"
}

const ListOfItems = ({ items, data, enableEdit = false }) => {
    const classes = useStyles();

    return (
        <>
            <div className={`${classes.headerList} ${classes.ListInsideViewDetails} listOfItemsCls`}>
                {items.map(({ display, ...rest }, index) => {
                    return (
                        <div key={display} className={classes.itemCard}>
                            <div>
                                <b>
                                    {display}
                                </b>
                                <span className="item-value">
                                <ListContent
                                    enableEdit={enableEdit}
                                    column={{
                                        ...rest,
                                        display
                                    }}
                                    data={data}
                                />
                                </span>
                            </div>
                        </div>
                    )
                })}
            </div>
        </>
    )
}
export default React.memo(ListOfItems)